import { Component, inject, Injector, OnInit, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { SigninForm } from "../../components/forms/signinForm/signinForm.component";
import { KeycloakAdminService } from "../../services/keycloak/keycloak.service";
import { signedInRedirectUrl } from "../../services/routing/routeGuards";

@Component({
    selector: 'sign-in',
    standalone: true,
    templateUrl: './signin.component.html',
    imports: [SigninForm]
})
export class SigninPage implements OnInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private injector = inject(Injector);
    private platformId = inject(PLATFORM_ID);

    /**
     * Already signed in with a valid token: skip the form and go to the
     * return URL (or the dashboard). redirectSignedInGuard does the same
     * before the page renders once it is on the '' route; this covers the
     * route until then. Mock mode keeps the form reachable (see the helper).
     */
    ngOnInit(): void {
        if (!isPlatformBrowser(this.platformId)) return;
        // Looked up here, not injected: its storage can't be built on the server.
        const kcService = this.injector.get(KeycloakAdminService);
        const target = signedInRedirectUrl(kcService, this.route.snapshot.queryParams);
        if (target) {
            this.router.navigateByUrl(target, { replaceUrl: true });
        }
    }
}
